import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useStyles } from './VideoTile';

VideoTileLocal.propTypes = {
  height: PropTypes.string,
  children: PropTypes.node,
};
export default function VideoTileLocal(props) {
  const classes = useStyles(props);
  const videoElement = useRef(null);

  const { localTileId, audioVideo } = useSelector(({ video, chime }) => ({
    localTileId: video.localTileId,
    audioVideo: chime.audioVideo,
  }));

  useEffect(() => {
    audioVideo.bindVideoElement(localTileId, videoElement.current);
    return () => {
      audioVideo.unbindVideoElement(localTileId);
    };
    // eslint-disable-next-line
  }, [localTileId]);

  return (
    <div data-testid="local-video-root" className={classes.root}>
      <video data-testid="video-tile" className={classes.video} ref={videoElement} />
      {props.children}
    </div>
  );
}
